import { countries } from 'countries-list';

const SPECIAL_DOMAINS = {
  US: 'google.com',
  GB: 'google.co.uk',
  UK: 'google.co.uk',
  CA: 'google.ca',
  AU: 'google.com.au',
  NZ: 'google.co.nz',
  IN: 'google.co.in',
  JP: 'google.co.jp',
  SG: 'google.com.sg',
  MY: 'google.com.my',
  ZA: 'google.co.za',
  BR: 'google.com.br',
  MX: 'google.com.mx',
  AR: 'google.com.ar',
  CL: 'google.cl',
  CO: 'google.com.co',
  PE: 'google.com.pe',
  VE: 'google.co.ve',
  FR: 'google.fr',
  DE: 'google.de',
  IT: 'google.it',
  ES: 'google.es',
  PT: 'google.pt',
  NL: 'google.nl',
  SE: 'google.se',
  NO: 'google.no',
  DK: 'google.dk',
  FI: 'google.fi',
  BE: 'google.be',
  AT: 'google.at',
  CH: 'google.ch',
  CN: 'google.cn',
  HK: 'google.com.hk',
  TW: 'google.com.tw',
  KR: 'google.co.kr',
  AE: 'google.ae',
  SA: 'google.com.sa'
};

const getGoogleDomain = (code) => SPECIAL_DOMAINS[code] || `google.${code.toLowerCase()}`;

const pickFirst = (value, fallback) => {
  if (!value) return fallback;
  if (Array.isArray(value)) return value[0] ?? fallback;
  if (typeof value === 'string') return value.split(',')[0] || fallback;
  return fallback;
};

const COUNTRIES = Object.entries(countries)
  .map(([code, data]) => {
    const upperCode = code.toUpperCase();
    const language = pickFirst(data.languages, 'en').toLowerCase();
    const currency = pickFirst(data.currency, 'USD').toUpperCase();
    const locale = `${language}-${upperCode}`;

    return {
      code: upperCode,
      name: data.name,
      capital: data.capital || data.name,
      language,
      locale,
      currency,
      googleDomain: getGoogleDomain(upperCode),
    };
  })
  .sort((a, b) => a.name.localeCompare(b.name));

export default COUNTRIES;
